import { useState } from 'react';
import { DropdownButton, Dropdown } from 'react-bootstrap';
import styles from 'widget/event_components/ticket-spot.scss';

export const OptionDropdown = ({ setCustomField, questionText, question, options, errors }) => {
  const [value, setValue] = useState('Select an option');
  const isError = !!errors[`custom_${questionText}`];
  return (
    <>
      <DropdownButton
        id="dropdown-basic-button"
        className={styles.ticketSelect}
        title={value}
        onSelect={(e) => {
          setValue(e);
          setCustomField('dropdown', question)(questionText, e);
        }}
      >
        {options.split('\n').map((option, index) => (
          <Dropdown.Item eventKey={option} isInvalid={isError} id={`${questionText}--${index}`}>
            {option}
          </Dropdown.Item>
        ))}
      </DropdownButton>
      {isError && (
        <div className="invalid-feedback" style={{ display: 'block' }}>
          {errors[`custom_${questionText}`]}
        </div>
      )}
    </>
  );
};
